import ActionTypes from "../../../../constants/ActionTypes";
import {
  ICartConflictDataAction,
  IClearBasketAction,
  IResolveConflictAction,
  ISetResolvingInProgressAction,
  ISubmitAccessoriesOrderAction,
  ISubmitOrderAction
} from "./types";

// Command
export const submitOrderAction = (): ISubmitOrderAction => ({
  type: ActionTypes.ORDER.SUBMIT
});

export const submitAccessoriesOrderAction = (): ISubmitAccessoriesOrderAction => ({
  type: ActionTypes.ORDER.SUBMIT_ACCESSORIES
});


export const resolveConflictAction = (orderType: any): IResolveConflictAction => ({
  type: ActionTypes.ORDER.RESOLVE_CONFLICT,
  payload: orderType
});

export const clearBasketAction = (): IClearBasketAction => ({
  type: ActionTypes.ORDER.CLEAR_BASKET
});

// Document
export const setCartConflictDataAction = (cartConflictData: any): ICartConflictDataAction => ({
  type: ActionTypes.ORDER.SET_CART_CONFLICT_DATA,
  payload: cartConflictData
});

export const setResolvingInProgressAction = (status: boolean): ISetResolvingInProgressAction => ({
  type: ActionTypes.ORDER.SET_RESOLVING_IN_PROGRESS,
  payload: status
});

